
import { computed, defineComponent, PropType } from 'vue';
import { Divider, Empty } from 'ant-design-vue';
import { IVendaItem } from '@/models/Entidades/Vendas/IVenda';
import VendaItemOrdemProducaoCard from '@/components/Vendas/Vendas/VendaItemOrdemProducaoCard.vue';

export default defineComponent({
  name: 'VendaOrdensProducaoVinculadasTab',
  components: {
    VendaItemOrdemProducaoCard,
    'a-empty': Empty,
    'a-divider': Divider,
  },
  props: {
    itens: {
      type: Array as PropType<IVendaItem[]>,
      required: true,
    },
  },
  setup(props) {
    const itensComOrdensProducao = computed(() => props.itens.filter((item) => item.ordensProducaoVinculadas && item.ordensProducaoVinculadas.length > 0));

    return {
      itensComOrdensProducao,
    };
  },
});
